import { render, staticRenderFns } from "./TabsNav.vue?vue&type=template&id=191e33e2&scoped=true&"
import script from "./TabsNav.vue?vue&type=script&lang=js&"
export * from "./TabsNav.vue?vue&type=script&lang=js&"
import style0 from "./TabsNav.vue?vue&type=style&index=0&id=191e33e2&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "191e33e2",
  null
  
)

export default component.exports